import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaMailSignatureTemplate = z.object({
    aggregateId: schemaId.optional(),
    createdAt: z.string().optional(),
    data: z.object({
        mailContent: z.string().min(1),
        mailHTMLContent: z.string().min(1),
    }),
    id: schemaId.optional(),
    name: z.string(),
    priority: z.union([z.number(), z.string()]).nullish(),
    type: z.literal(TEMPLATE_TYPES.MAIL_SIGNATURE),
    users: z.array(schemaId).nullish(),
});

export type SchemaMailSignatureTemplate = z.infer<typeof schemaMailSignatureTemplate>;
